<template>
    <div>
        <navbar></navbar>
        <div class="container">
            <p class="__portpnew">Building Anfana — Everyday Shopping, Seamlessly Digital</p>
            <p class="__portp2new">Findworka turned a bold vision—“make fashion, gadgets and essentials just a click away for everyone, everywhere”—into a fast, intuitive e-commerce platform that vendors love and Gen Z shoppers can’t quit.</p>
            <p class="__meetdname"><span class="__namp">Client Name:</span> Anfana </p>
            <p class="__meetdname"><span class="__namp">Product:</span> E-commerce platform for fashion, gadgets & essentials</p>
            <p class="__meetdname"><span class="__namp">Scope:</span> UX/UI, vendor backend, multi-currency checkout, order tracking, mobile optimisation.</p>
            <p class="__headin">The Challenge</p>

            <p class="__meetdname"><span class="__namp">Stand Out in a Crowded Marketplace</span></p>
            <ul class="__portp2new">
                <li>Needed a user experience that’s fast, intuitive and beautiful</li>
                <li>Seamless vendor onboarding & inventory management</li>
                <li>Secure, multi-currency checkout </li>
                <li>Strong mobile performance and sub-3-second load speeds</li>
                <li>Backend ready for scale</li>
            </ul>

            <p class="__headin">The Solution</p>
            <p class="__meetdname"><span class="__namp">Digital-Mall Mind-Set —</span>  from wireframe to launch we built with functionality, design and the shopper in mind.</p>
            <p class="__meetdname">We approached the project as both engineers and designers of experience. Our first step was immersing ourselves in the data — understanding what mattered, what didn’t, and how users would want to engage with the dashboard. Here’s what we built:</p>
            <ul class="__portp2new">
                <li><b class="__namp">Modern UI/UX Design – </b>clean, distraction-free layout with smart filters, intuitive categories and gorgeous product displays.</li>
                <li><b class="__namp">Vendor Dashboard – </b>upload products, manage stock and track sales; a vendor can be live in 10 minutes.</li>
                <li><b class="__namp">Secure Payment Integration –</b>Paystack, Flutterwave and wallet systems for friction-free regional payments.</li>
                <li><b class="__namp">Real-Time Order Management – </b>buyers track orders end-to-end; vendors get live notifications and analytics.</li>
                <li><b class="__namp">Mobile Optimisation – </b>zero-lag experience for the 70 % of customers who browse on phone.</li>
                <li><b class="__namp">Scalable Architecture –</b>robust backend supports thousands of SKUs and future features (wish-lists, reviews, flash sales).</li>
            </ul>
            <img src="../assets/img/trackalanding.png" class="__climgr"/>

            <p class="__headin">Key Features</p>
            <div class="row">
                <div class="col-xl-4 col-lg-4 col-md-4">
                    <div class="__cards">
                        <img src="../assets/img/ftux-design.png" class="__futimg"/>
                        <p class="__meetdname"><span class="__namp">Modern UI/UX</span></p>
                        <p class="__meetdname">Smart filters & fast search</p>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4">
                    <div class="__cards">
                        <img src="../assets/img/ftworkforce.png" class="__futimg"/>
                        <p class="__meetdname"><span class="__namp">Vendor Dashboard</span></p>
                        <p class="__meetdname">10-min onboarding</p>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4">
                    <div class="__cards">
                        <img src="../assets/img/ftshopping-bag.png" class="__futimg"/>
                        <p class="__meetdname"><span class="__namp">Multi-Currency Checkout</span></p>
                        <p class="__meetdname">Paystack · Flutterwave · Wallet</p>
                    </div>
                </div>
            </div>

            <p class="__headin">Client Testimonial</p>
            <p class="__meetdname">“Customers love how easy it is to shop, pay and get things delivered, while vendors love the backend simplicity and analytics.” <span class="__namp"><i>— Anfana Operations Team</i></span></p>

            <p class="__headin">Results / Impact Tiles</p>
            <div class="row">
                <div class="col-xl-4 col-lg-4 col-md-4">
                    <div class="__card1">
                        <p class="__meetdname"><span class="__namp">Products Live</span></p>
                        <p class="__meetdname">1,500 +</p>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4">
                    <div class="__card1">
                        <p class="__meetdname"><span class="__namp">Vendors Onboarded</span></p>
                        <p class="__meetdname">Dozens</p>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4">
                    <div class="__card1">
                        <p class="__meetdname"><span class="__namp">Mobile Shoppers</span></p>
                        <p class="__meetdname">70 % of traffic</p>
                    </div>
                </div>
            </div><br>
            <p class="__meetdname">In a space where user loyalty is won by convenience and trust, Anfana stands tall because it was built with both in mind. At Findworka, we don’t just build platforms — we build experiences with your users at the centre.</p>

            

            <div class="text-center">
                <p class="__hvsip">Have an idea to ship? Let’s build it—fast.</p>
                <p class="__meetdname">Tell us about your product vision and get a scoped build plan within 48 hours.</p>
                <router-link to="/build" class="btn __viewsite">Get Started Here </router-link>
            </div>
            <div class="__whitespace"></div>
        </div>
    </div>
</template>


<script>
import navbar from '../components/navbar';

export default {
    components: { navbar },
    data(){
        return{}
    },
}
</script>

<style scoped>
@import '../assets/css/portfolio';
</style>


// WEBPACK FOOTER //
// src/components/anfana.vue